import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/salesCopy';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-night" data-id="element-73" data-mp="1bmlievk97beo">
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-74" data-mp="1gitw04isywjq">
        <div className="text-center" data-id="element-75" data-mp="249g41vst4gtq">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-76" data-mp="24ahfw2hnd7ci">
            Frequently asked questions
          </p>
          <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-77" data-mp="1ujwhaf1z42tl">
            Before you <span className="text-gold" data-id="element-78" data-mp="1zgwpowmaphnv">decide</span>
          </h2>
        </div>

        <ul className="mt-9 space-y-3 sm:mt-12" data-id="element-79" data-mp="2n70s50nqzbda">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <li key={faq.question} className="overflow-hidden rounded-xl border border-line bg-panel" data-id="element-80" data-mp="2s0llgfeebh65" data-mpi={i}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5" data-id="element-81" data-mp="10v04agp7dyle">
                  <span className="text-[15px] font-semibold leading-snug text-cream sm:text-lg" data-id="element-82" data-mp="1oi8bj466zhq2">
                    {faq.question}
                  </span>
                  <PlusIcon className={['h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-expo', isOpen ? 'rotate-45' : 'rotate-0'].join(' ')} aria-hidden="true" data-id="element-83" data-mp="1xjzbrthyqwcj" />
                </button>
                <AnimatePresence initial={false} data-id="element-84" data-mp="3ud19kfl0t7u2">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-85" data-mp="1y9mp13hkk4a4">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-cream-muted sm:px-6" data-id="element-86" data-mp="2c6rqsra92gzk">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}